// breadcrumbs'y
//@ts-nocheck

import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

import { useSelector } from 'store';
import { useAppNavigate } from 'hooks';
import { Container } from 'components/controls';

import styles from 'theme/components/controls/Breadcrumbs/Breadcrumbs.module.scss';

// Buduje pełny URL z (potencjalnie względnej) ścieżki breadcrumba.
// Dla ostatniego elementu bez ścieżki używamy bieżącego adresu strony.
const buildAbsoluteUrl = (path?: string) => {
  if (!path) return window.location.href;
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  return `${window.location.origin}${path.startsWith('/') ? '' : '/'}${path}`;
};

const Breadcrumbs = ({ isLoading = false }: { isLoading?: boolean }) => {
  const { t } = useTranslation();
  const navigate = useAppNavigate();
  const { breadcrumbs } = useSelector((state) => state.ui);

  return (
    <div
      className={classnames(styles.componentWrapper, 'StylePath-Components-Controls-Breadcrumbs')}
      itemScope
      itemType="http://schema.org/BreadcrumbList">
      <Container>
        <div className={styles.breadcrumbs}>
          {/* Element "Strona główna" jest pełnoprawnym ListItem na pozycji 1,
              dzięki czemu BreadcrumbList zawiera komplet pozycji wymaganych przez Google. */}
          <span
            onClick={() => navigate('/')}
            className={styles.home}
            itemProp="itemListElement"
            itemScope
            itemType="http://schema.org/ListItem">
            <meta itemProp="item" content={`${window.location.origin}/`} />
            <meta itemProp="position" content="1" />
            <span itemProp="name">{t('Strona główna')}</span>
          </span>

          {!isLoading &&
            breadcrumbs.map(({ name, path }, index) => {
              const isLast = index === breadcrumbs.length - 1;
              // Home zajmuje pozycję 1, więc kolejne elementy numerujemy od 2.
              const position = index + 2;
              // schema.org wymaga, by "item" było pełnym URL-em (nie ścieżką względną).
              const itemUrl = buildAbsoluteUrl(path);
              return (
                <span
                  key={`${path}-${name}`}
                  className={styles.breadcrumb}
                  itemProp="itemListElement"
                  itemScope
                  itemType="http://schema.org/ListItem">
                  <meta itemProp="item" content={itemUrl} />
                  <meta itemProp="position" content={String(position)} />
                  <span className={styles.separator}>/</span>
                  <span
                    onClick={() => path && !isLast && navigate(path)}
                    className={classnames(styles.name, { [styles.disabled]: !path || isLast })}
                    itemProp="name">
                    {name}
                  </span>
                </span>
              );
            })}
        </div>
      </Container>
    </div>
  );
};

export default Breadcrumbs;

